import { useEffect, useState } from "react";
import { IconAlertTriangle } from "@tabler/icons-react";
import { useNotificationsStore } from "../stores/notificationsStore";

const SHOW_AFTER_MS = 10_000;

/**
 * Faixa de aviso quando o stream de notificações cai por mais de 10s. Montada
 * uma vez no AppLayout. Mesmo comportamento do crm/launches.
 */
export function DisconnectedBanner() {
  const status = useNotificationsStore((s) => s.connectionStatus);
  const disconnectedSince = useNotificationsStore((s) => s.disconnectedSince);
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    if (status === "connected" || !disconnectedSince) {
      setShouldShow(false);
      return;
    }
    const elapsed = Date.now() - disconnectedSince;
    if (elapsed >= SHOW_AFTER_MS) {
      setShouldShow(true);
      return;
    }
    const timer = window.setTimeout(() => setShouldShow(true), SHOW_AFTER_MS - elapsed);
    return () => window.clearTimeout(timer);
  }, [status, disconnectedSince]);

  if (!shouldShow || status === "connected") return null;

  return (
    <div
      role="status"
      className="flex items-center gap-2 border-b border-warning bg-warning-soft px-4 py-1.5 text-[12px] font-medium text-warning-ink"
    >
      <IconAlertTriangle size={14} />
      Notificações em tempo real indisponíveis — tentando reconectar…
    </div>
  );
}
